import classNames from "../../../utils/classNames"

export const NumberInput = ({ label, register, registerName, step = ".01", classes = "", minVal, inputClasses = "" }) => {

  return (
    <div className={classNames(classes, "sm:col-span-1")}>
      {label && <label className="text-sm font-medium text-gray-500 ">{label}</label>}
      <input {...register(registerName)} type="number" step={step} min={minVal} className={`w-full text-sm text-gray-900 border-1 border-gray-300 rounded-md shadow-sm ${inputClasses} ${label && "mt-1"}`} />
    </div>
  )
}